// extracted by mini-css-extract-plugin
export var activeLayout = "blog-module--active-layout--UCZuR";
export var body = "blog-module--body--3zjwl";
export var sidebarImage = "blog-module--sidebar-image--ze2x3";
export var image = "blog-module--image--2fasZ";
export var block = "blog-module--block--32HvB";
export var navBar = "blog-module--navBar--2moty";
export var top = "blog-module--top--29q8C";
export var posts = "blog-module--posts--XBdcU";